var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZmrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.355 0H14.6347L-0.000244141 14.6445V35.3555L14.6446 50H35.3648L50.0096 35.3555V14.6445L35.355 0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.875 31.2686L41.0516 36.0824L34.7818 29.8136L28.5159 36.0824L23.7024 31.2686L29.9722 24.9998L23.7024 18.7311L28.5159 13.9172L34.7838 20.186L41.0536 13.9172L45.875 18.7311L39.6052 24.9998L45.875 31.2686Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7292 15L25.7292 25L15.7292 35V29.5147H4.30005L8.06208 20.4874H15.7292V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZmrc);
export default __webpack_public_path__ + "static/media/ZMRC.5c30f648b629b6e1984eba9b666937da.svg";
export { ForwardRef as ReactComponent };